<template>
    <div class="detail-take-order-page" ref="takeOrderPage">
        <div class="page-wrap">
            <div class="page-title">
                <span  class="text1 backIcon"  @click="$router.go(-1)"><i class="el-icon-arrow-left"></i> 返回</span>
                <span class="text1">生产加工</span> 
                <i class="el-icon-arrow-right arrow-right"></i>
                <span class="text2">订单详情</span> 
            </div>
            <div class="page-sub-title">来料加工订单</div>
            <div class="detail-main-wrap">
                <div class="cover-info">
                    <img class="cover-img" :src="headImg" alt="" @click="handleImgPreview(headImg)">
                    <div class="right-box">
                        <div class="name-line">
                            {{detailData.orderName}}
                        </div>
                        <div class="style-line">
                            <span class="key">款式分类</span>
                            <span class="key">{{detailData.orderStyleMemo}}</span>
                        </div>
                        <div class="style-line">
                            <span class="key">单价</span>
                            <span class="key">{{detailData.orderUnitPrice}}元/件</span>
                        </div>
                    </div>
                </div>
                <el-row>
                    <el-col :span="8">
                        <div class="line-info">
                            <span class="key">订单类型</span>
                            <span class="value">
                                {{detailData.orderType === 'cmt' ? '来料加工' : ''}}
                                {{detailData.orderType === 'oem' ? '包工包料' : ''}}
                            </span>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="line-info">
                            <span class="key">订单数量</span>
                            <span class="value">{{detailData.orderQuantity}}件</span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <div class="line-info">
                            <span class="key">交货日期</span>
                            <span class="value">{{detailData.orderDeliveryTime}}</span>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="line-info">
                            <span class="key">订单编号</span>
                            <span class="value">{{detailData.orderNumber}}</span>
                        </div>
                    </el-col>
                </el-row>
                <div class="right-info">
                    <div>
                        <span class="text1"><i class="el-icon-alarm-clock"></i> 抢单截止时间：</span>
                        <span class="text2">{{detailData.orderTakingEndTime}}</span>
                    </div>
                    <div style="margin-top: 16px; text-align: right">
                        <el-button type="primary" size="small" @click="scrollToBottom">意向接单</el-button>
                    </div>
                </div>
            </div>

            <div class="mod-title">
                支付信息
            </div>
            <div class="pay-box">
                <el-row>
                    <el-col :span="6">
                        <div>
                            <span class="c-font black">预付款 </span>
                            <span class="c-font grey">{{payInfoStr.order_advance_payment_percent}}%</span>
                        </div>
                        <div><span class="c-font red mgt-8">￥{{payInfoStr.orderAdvancePayment}}</span></div>
                    </el-col>
                    <el-col :span="6">
                        <div>
                            <span class="c-font black">交货款 </span>
                            <span class="c-font grey">{{payInfoStr.order_delivery_payment_percent}}%</span>
                        </div>
                        <div><span class="c-font red mgt-8">￥{{payInfoStr.orderDeliveryPayment}}</span></div>
                    </el-col>
                    <el-col :span="6">
                        <div>
                            <span class="c-font black">尾款/质保金 </span>
                            <span class="c-font grey">{{payInfoStr.tail_money_pecent}}%</span>
                        </div>
                        <div><span class="c-font red mgt-8">￥{{payInfoStr.tailMoney}}</span></div>
                    </el-col>
                </el-row>
                <div style="margin-top: 24px">
                    <span class="c-font black" v-if="payInfoStr.order_is_include_tax == 'y'">该订单报价为含税报价</span>
                    <span class="c-font black" v-if="payInfoStr.order_is_include_tax == 'y'">该订单报价为不含税报价</span>
                </div>
                <el-row style="margin-top: 24px">
                    <el-col :span="6">
                        <div><span class="c-font black">平台收费</span></div>
                        <div><span class="c-font red mgt-8">{{serviceFeeInfo}}</span></div>
                    </el-col>
                    <el-col :span="6">
                        <div><span class="c-font black">总金额</span></div>
                        <div><span class="c-font black mgt-8">¥{{payInfoStr.order_total_price}}</span></div>
                    </el-col>
                </el-row>
            </div>
            <div style="padding: 10px 0 0 24px">
                <span class="c-font grey">说明：请注意付款的时间阶段和对应比例</span>
            </div>

            <div class="mod-title">
                基础资料
            </div>
            <div class="basic-material">
                <div class="line">
                    <span class="c-font grey">品牌商提供资料</span>
                    <div class="line-content">
                        <template v-if="needInfomation.listStr.length > 0 || needInfomation.other">
                            <span class="c-font black" v-for="(item, index) in needInfomation.listStr" :key="index">{{item}}</span>
                            <span class="c-font black" v-if="needInfomation.other">{{needInfomation.other}}</span>
                        </template>
                        <template v-else>
                            未填写
                        </template>
                    </div>
                </div>
                <div class="line">
                    <span class="c-font grey">需要生产商制作</span>
                    <div class="line-content">
                        <template v-if="needProducerDo.listStr.length > 0 || needProducerDo.other">
                            <span class="c-font black" v-for="(item, index) in needProducerDo.listStr" :key="index">{{item}}</span>
                            <span class="c-font black" v-if="needProducerDo.other">{{needProducerDo.other}}</span>
                        </template>
                        <template v-else>
                            未填写
                        </template>
                    </div>
                </div>
                <div class="line">
                    <span class="c-font grey">需要加工的环节</span>
                    <div class="line-content">
                        <template v-if="needProcessingLink.listStr.length > 0 || needProcessingLink.other">
                            <span class="c-font black" v-for="(item, index) in needProcessingLink.listStr" :key="index">{{item}}</span>
                            <span class="c-font black" v-if="needProcessingLink.other">{{needProcessingLink.other}}</span>
                        </template>
                        <template v-else>
                            未填写
                        </template>
                    </div>
                </div>
                <div class="line">
                    <span class="c-font grey">特殊工艺</span>
                    <div class="line-content">
                        <template v-if="specialProcess.listStr.length > 0 || specialProcess.other">
                            <span class="c-font black" v-for="(item, index) in specialProcess.listStr" :key="index">{{item}}</span>
                            <span class="c-font black" v-if="specialProcess.other">{{specialProcess.other}}</span>
                        </template>
                        <template v-else>
                            未填写
                        </template>
                    </div>
                </div>
                <div class="line">
                    <span class="c-font grey">品质要求</span>
                    <div class="line-content">
                        <span class="c-font black">{{detailData.quantityStr}}</span>
                    </div>
                </div>
            </div>

            <div class="mod-title">
                交货信息
            </div>
            <div>
                <el-row style="padding-top: 24px" v-if="detailData.orderType === 'cmt'">
                    <el-col :span="8">
                        <span class="c-font grey">预计面辅料到齐时间</span>
                        <div>
                            <span class="c-font black mgt-8">{{detailData.orderMaterialReadyTime}}</span>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <span class="c-font grey">面辅料提供情况</span>
                        <div>
                            <span class="c-font black mgt-8">{{detailData.fabricSupply}}</span>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <span class="c-font grey">面辅料运费承担方</span>
                        <div>
                            <span class="c-font black mgt-8">{{detailData.fabricFreightChargeBearer}}</span>
                        </div>
                    </el-col>
                </el-row>
                <el-row style="padding-top: 24px">
                    <el-col :span="8">
                        <span class="c-font grey">交货方式</span>
                        <div>
                            <span class="c-font black mgt-8">{{detailData.deliveryMethod ? detailData.deliveryMethod : '未填写'}}</span>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <span class="c-font grey">大货运费承担方</span>
                        <div>
                            <span class="c-font black mgt-8">{{detailData.highFreightChargeBearer}}</span>
                        </div>
                    </el-col>
                </el-row>
            </div>


            <div class="mod-title">
                颜色-尺寸-数量
            </div>

            <div class="size-table-wrap">
                <table class="size-table">
                    <tr>
                        <th  v-for="(item, i) in colorSizeGroup" :key="i">{{item.color}}</th>
                    </tr>
                    <tr v-for="(item, i) in colorSizeGroup[0] && colorSizeGroup[0].sizeArr" :key="i">
                        <td v-for="(ele, j) in colorSizeGroup" :key="j">{{colorSizeGroup[j].sizeArr[i].number}}</td>
                    </tr>
                    
                </table>
            </div>

            <div class="mod-title">
                样衣/款式详情图片
            </div>
            <div class="style-wrap">
                <div>
                    <span class="c-font grey">样式说明</span>
                    <div>
                        <span class="c-font black mgt-8">{{detailData.styleDes}}</span>
                    </div>
                </div>
                <div class="style-imgs">
                    <img class="img" v-for="(item, i) in styleImageArray" :key="i" :src="item" alt=""
                        @click="handleImgPreview(item)"
                    >
                </div>
            </div>

            <div class="mod-title">
                面辅料信息
            </div>
            <template v-if="fabricInfoGroup.length > 0">
                <div class="fabric-material" v-for="(item, index) in fabricInfoGroup" :key="index">
                    <div style="padding-top: 24px;">
                        <span class="c-font blue">面料{{letterArray[index]}}</span>
                    </div>
                    <el-row style="margin-top: 24px">
                        <el-col :span="8">
                            <span class="c-font grey">面料名称</span>
                            <div>
                                <span class="c-font black mgt-8">{{item.name ? item.name :  '未填写'}}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top: 24px"  v-if="detailData.orderType=='oem'">
                        <el-col :span="8">
                            <span class="c-font grey">是否指定供应商</span>
                            <div>
                                <span class="c-font black mgt-8">
                                    {{item.nominatedSupplier === '1' ? '是': ''}}
                                    {{item.nominatedSupplier === '0' ? '否': ''}}
                                    {{item.nominatedSupplier === '' ? '未填写': ''}}
                                </span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <span class="c-font grey">面料主成分</span>
                            <div>
                                <span class="c-font black mgt-8">{{item.fabricMain ? item.fabricMain : '未填写'}}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <span class="c-font grey">面料克重</span>
                            <div>
                                <span class="c-font black mgt-8">{{item.fabricGramWeight ? item.fabricGramWeight + '克/平方米' : '未填写'}}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top: 24px"  v-if="detailData.orderType=='cmt'">
                        <el-col :span="8">
                            <span class="c-font grey">门幅宽度</span>
                            <div>
                                <span class="c-font black mgt-8">{{item.doorWidth ? item.doorWidth + '厘米' : '未填写'}}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <span class="c-font grey">单件用量</span>
                            <div>
                                <span class="c-font black mgt-8">{{item.estimateUsage ? item.estimateUsage + '米' : '未填写'}}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <span class="c-font grey">缩率</span>
                            <div>
                                <span class="c-font black mgt-8">{{item.reduceRatio ? item.reduceRatio+'%' : '未填写'}}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top: 24px">
                        <el-col :span="8">
                            <span class="c-font grey mgr-8">是否需要复合</span>
                            <span class="c-font black">
                                {{item.recombination === '1' ? '是': ''}}
                                {{item.recombination === '0' ? '否': ''}}
                                {{item.recombination === '' ? '未填写': ''}}
                            </span>
                        </el-col>
                        <el-col :span="8">
                            <span class="c-font grey mgr-8">是否需要水洗</span>
                            <span class="c-font black">
                                {{item.washing === '1' ? '是': ''}}
                                {{item.washing === '0' ? '否': ''}}
                                {{item.washing === '' ? '未填写': ''}}
                            </span>
                        </el-col>
                        <el-col :span="8">
                            <span class="c-font grey mgr-8">是否需要缩水</span>
                            <span class="c-font black">
                                {{item.shrink === '1' ? '是': ''}}
                                {{item.shrink === '0' ? '否': ''}}
                                {{item.shrink === '' ? '未填写': ''}}
                            </span>
                        </el-col>
                    </el-row>
                    <div style="margin-top: 24px">
                        <span class="c-font grey">面料图片</span>
                        <div class="style-imgs">
                            <img class="img" v-for="(ele, num) in item.fabricImgs" :key="ele+num" :src="ele" alt=""
                                @click="handleImgPreview(ele)"
                            >
                            <img class="img" v-for="(ele, num) in item.fabricParamImgs" :key="ele+num" :src="ele" alt=""
                                @click="handleImgPreview(ele)"
                            >
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div>
                    <span class="c-font black">面料信息未填写</span>
                </div>
            </template>
            <div>
                <div style="margin-top: 24px">
                    <span class="c-font grey">辅料</span>
                    <div>
                        <template v-if="excipient.listStr.length > 0 || excipient.other">
                            <span class="c-font black" v-for="(item, index) in excipient.listStr" :key="index">{{item}}</span>
                            <span class="c-font black" v-if="excipient.other">{{excipient.other}}</span>
                        </template>
                        <template v-else>
                            未填写
                        </template>
                    </div>
                </div>

                <div style="margin-top: 24px">
                    <span class="c-font grey">面辅料补充说明</span>
                    <div>
                        <span class="c-font black">{{fabricInformationStr.supplementInfo ? fabricInformationStr.supplementInfo : '未填写'}}</span>
                    </div>
                </div>
                
            </div>

            <div class="mod-title">
                订单备注
            </div>
            <div style="margin-top: 24px;">
                <span class="c-font black">{{detailData.intentionalOrderRemark ? detailData.intentionalOrderRemark : '未填写'}}</span>
            </div>

            <div class="address-box">
                <div class="address-box-title">
                    请选择联系方式
                </div>
                <div class="contact">
                    <template v-if="addressSelect.address_id">
                        <div style="margin-top: 24px; width: 50%">
                            <span class="c-font black mgr-8">{{addressSelect.address_contact_name}}</span>
                            <span class="c-font black">{{addressSelect.address_contact_phone}}</span>
                            
                        </div>
                        <div style="margin-top: 4px">
                            <span class="c-font black">
                                {{addressSelect.region_province_string}}
                                {{addressSelect.region_city_string}}
                                {{addressSelect.region_district_string}}
                                {{addressSelect.address_string}}
                            </span>
                        </div>
                    </template>
                    
                    <div style="margin-top: 24px">
                        <el-button size="small" type="warning" @click="addressVisable = true">选择联系方式</el-button>
                    </div>
                </div>
            </div>

            <div style="margin-top: 48px" ref="footerBtn">
                <el-button size="small" style="margin-right: 24px" @click="$router.go(-1)">返回</el-button>
                <el-button type="primary" size="small" @click="submitOrder">意向接单</el-button>
            </div>
            
        </div>

        <address-list-model :visible.sync="addressVisable" @get-address="getAddress" />

        <el-dialog :visible.sync="dialogImgVisible">
            <img width="100%" :src="dialogImgUrl" alt="">
        </el-dialog>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import api from '@/api/index.js'
    import request from '@/utils/request'
    import addressListModel from '../address/components/addressListModel.vue'

    export default {
        components: {
            addressListModel
        },
        data() {
            return {
                dialogImgUrl: '',
                dialogImgVisible:false,

                loading: false,
                addressVisable: false,

                detailData: {
					orderTakingEndTime: '',
					orderNumber: '',
					orderName: '',
					orderStyleMemo: '',
					orderQuantity: '',
					orderUnitPrice: '',
					orderDeliveryTime: '',
				}, // 所有数据
				payInfoStr: {
					order_advance_payment_percent: '',
					orderAdvancePayment: '',
					order_delivery_payment_percent: '',
					orderDeliveryPayment: '',
					tail_money_pecent: '',
					tailMoney: '',
					order_is_include_tax: '',
					order_total_price: ''
				}, // 支付数据
				needInfomation: { // 您提供的资料
					listStr: [],
					other: ''
				}, 
				needProducerDo: { // 需要生产商制作
					listStr: [],
					other: ''
				}, 
				needProcessingLink: { // 需要加工环节
					listStr: [],
					other: ''
				}, 
				specialProcess: { //特殊工艺
					listStr: [],
					other: ''
				},
				contactInformationStr: { // 品牌商联系方式
					address_contact_name: '',
					address_contact_phone: '',
					address: ''
				},
                styleImage: {}, // 样式图片
                styleImageArray: [], // 样式图片数组
				styleImagePreview: [],
				fabricInformationStr: { // 面辅料信息	
		
				}, 
				fabricInfoGroup: [],  // 面料信息
				fabricInformationStrPreview: [],
				excipient: { // 辅料信息
					listStr: [],
					other: ''
				},
				orderAdditionalMaterials: {}, // 补充信息
				checkGoodsImg: [], // 补充信息 -- 查货方式图片
				sizeTableImg: [], // 补充信息 -- 尺码表图片
				technologyImg: [], // 补充信息 -- 工艺单图片
				headImg: '', // 顶部图
				colorSizeQuantityStr: {
					orderQuantity: ''
				}, // 尺码，颜色
				colorSizeGroup: [], // 尺码，颜色组
				imgUrlPrev: '', // 图片前缀
				letterArray: ['A', 'B', 'C','D','E','F','G','H','I','J','K','L','M', 'N','O','P','Q','R','S','T','U','V','W','X','Y','Z'], // 字母表
                serviceFeeInfo: '', //服务费说明

                addressSelect: {}
                
            }
        },
        watch: {

        },
        computed: {
            ...mapGetters([
                'userId', 'token', 'phone', 'userInfo', 'userIsAuth', 'servicePhone'
            ])
        },
        created() {
            this.getData1()
            this.getData2()
            this.getData3()
            this.getModuleConfig()
            this.getDetaultAddress()
        },
        mounted() {
            this.setBodyBgColor('mounted')
        },
        beforeDestroy() {
            this.setBodyBgColor('beforeDestroy')
        },
        methods: {
            // 设置body背景色
            setBodyBgColor(sign) {
                if (sign === 'mounted') {
                    document.querySelector('body').setAttribute('style', 'background-color: #fff')
                    return;
                }
                if (sign === 'beforeDestroy') {
                    document.querySelector('body').removeAttribute('style')
                    return;
                }
            },
             // 滚动
            scrollToBottom() {
                let offsetTop = this.$refs.footerBtn.offsetTop;
                window.scrollTo({ 
                    top: offsetTop, 
                    behavior: "smooth" 
                })
            },
            // 图片预览
            handleImgPreview(url) {
                this.dialogImgUrl = url;
                this.dialogImgVisible = true;
            },
            // 获取详情数据
            getData1() {
                request({
                    url: api.orderDetailsShow,
                    data: {
                        userId: this.$route.query.brandUserId,
                        orderNumber: this.$route.query.orderNumber,
						orderType: this.$route.query.orderType
                    }
                }).then(res => {
                    // console.log(res)
                    if (res.errorCode == 200) {
                        this.detailData = res.data;
                        let payInfoStr = JSON.parse(res.data.payInfoStr);
                        this.payInfoStr = {
                            ...payInfoStr,
                            orderDeliveryPayment: payInfoStr.orderDeliveryPayment.toFixed(2),
                            order_total_price: payInfoStr.order_total_price.toFixed(2),
                            orderAdvancePayment: payInfoStr.orderAdvancePayment.toFixed(2),
                            tailMoney: payInfoStr.tailMoney.toFixed(2),
                        }
                        
                        this.needInfomation = this.formatData(res.data.needInfomation);
                        this.needProducerDo =  this.formatData(res.data.needProducerDo);
                        this.needProcessingLink = this.formatData(res.data.needProcessingLink);
                        this.specialProcess = this.formatData(res.data.specialProcess);
                        
                        this.contactInformationStr = res.data.contactInformationStr;
                        
                        this.styleImage = JSON.parse(res.data.imageJson);
                        this.headImg =  this.styleImage && this.styleImage.positiveImg && this.styleImage.positiveImg[0] ? api.imgPrev + this.styleImage.positiveImg[0].image_file : '';
            
                        if (this.styleImage && this.styleImage.positiveImg && this.styleImage.positiveImg[0].image_file) {
                            let styleImg = api.imgPrev + this.styleImage.positiveImg[0].image_file
                            this.styleImageArray.push(styleImg)
                        }
                        if (this.styleImage && this.styleImage.negativeImg && this.styleImage.negativeImg[0].image_file) {
                            let styleImg = api.imgPrev + this.styleImage.negativeImg[0].image_file
                            this.styleImageArray.push(styleImg)
                        }
                        if (this.styleImage && this.styleImage.detailsImg) {
                            let detailsImg = this.styleImage.detailsImg.map(item => api.imgPrev + item.image_file)
                            this.styleImageArray = this.styleImageArray.concat(detailsImg)
                        }

                        
                        // 尺码颜色列表
                        this.colorSizeQuantityStr = JSON.parse(res.data.colorSizeQuantityStr);
                        if (this.colorSizeQuantityStr.group) {
                            let colorSizeGroup = this.colorSizeQuantityStr.group;
                            let sizeArray = colorSizeGroup[0].sizeArr.map(item => {
                                return {
                                    name: item.name,
                                    number: item.name
                                }
                            });
                            let sizeLabel = {
                                color: '尺码',
                                sizeArr: sizeArray,
                                sum: '合计'
                            };
                            this.colorSizeGroup = [sizeLabel].concat(colorSizeGroup)
                            // console.log(this.colorSizeGroup);
                        }
                    } else {
                        this.$message.error(res.errorMsg || '网络错误')
                    }
                })
            },
            // 获取面料信息
            getData2() {
                request({
                    url: api.fabicInformation,
                    data: {
                        userId: this.$route.query.brandUserId,
                        orderNumber: this.$route.query.orderNumber,
						orderType: this.$route.query.orderType
                    }
                }).then(res => {
                    // console.log(res)
                    if (res.errorCode == 200) {
                        this.fabricInformationStr = res.data.fabricInformationStr ? res.data.fabricInformationStr : {};
                        if (this.fabricInformationStr.group) {
                            this.fabricInfoGroup = this.fabricInformationStr.group;
                            if(this.fabricInfoGroup) {
                                this.fabricInfoGroup.forEach(item => {
                                    if(item.imageJson && item.imageJson[0] && item.imageJson[0].fabricImgs) {
                                        item.fabricImgs = item.imageJson[0].fabricImgs.map(ele => api.imgPrev + ele.image_file)
                                    } else {
                                        item.fabricImgs = []
                                    }
                                    if(item.imageJson && item.imageJson[0] && item.imageJson[0].fabricParamImgs) {
                                        item.fabricParamImgs = item.imageJson[0].fabricParamImgs.map(ele => api.imgPrev + ele.image_file)
                                    } else {
                                        item.fabricParamImgs = []
                                    }
                                })
                                
                                // this.fabricInfoGroup.forEach(item => {
                                //     item.fabricImgs.forEach(ele => {
                                //         this.fabricInformationStrPreview.push(this.imgUrlPrev + ele.image_file)
                                //     })
                                //     item.fabricParamImgs.forEach(ele => {
                                //         this.fabricInformationStrPreview.push(this.imgUrlPrev + ele.image_file)
                                //     })
                                // })
                            }
                        }
                        if (this.fabricInformationStr.excipient) {this.excipient = this.formatData(this.fabricInformationStr.excipient);}
                    } else {
                        this.$message.error(res.errorMsg || '网络错误')
                    }
                })
            },
            // 获取补充资料
            getData3() {
                request({
                    url: api.additionalMaterialsShow,
                    data: {
                        userId: this.$route.query.brandUserId,
                        orderNumber: this.$route.query.orderNumber,
						orderType: this.$route.query.orderType
                    }
                }).then(res => {
                    // console.log(res)
                    if (res.errorCode == 200) {
                        this.orderAdditionalMaterials = res.data.orderAdditionalMaterials ? res.data.orderAdditionalMaterials : {}
                        if (res.data.orderAdditionalMaterialsPic) {
                            if (res.data.orderAdditionalMaterialsPic.checkGoodsImg) {
                                this.checkGoodsImg = res.data.orderAdditionalMaterialsPic.checkGoodsImg.map(item => {
                                    return api.imgPrev + item.image_file
                                })
                            }
                            if (res.data.orderAdditionalMaterialsPic.sizeTableImg) {
                                this.sizeTableImg = res.data.orderAdditionalMaterialsPic.sizeTableImg.map(item => {
                                    return api.imgPrev + item.image_file
                                })
                            }
                            if (res.data.orderAdditionalMaterialsPic.technologyImg) {
                                this.technologyImg = res.data.orderAdditionalMaterialsPic.technologyImg.map(item => {
                                    return api.imgPrev + item.image_file
                                })
                            }
                        }
                    } else {
                        this.$message.error(res.errorMsg || '网络错误')
                    }
                })
            },
            // 获取服务费说明
            getModuleConfig() {
                request({
                    url: api.getAppConfigInfo,
                    data: {
                        type: '1',
                        configName: "app_order_conference_switch",
                        userId: this.userId
                    }
                }).then(res => {
                    // console.log(res)
                    if (res.errorCode == 200) {
                        if (res.data && res.data[1]) {
                            this.serviceFeeInfo = res.data[1].config_value;
                        }
                    } else {
                        this.$message.error(res.errorMsg || '网络错误')
                    }
                })
            },
            // 获取默认地址
            getDetaultAddress() {
                const localAddressSelectStr = sessionStorage.getItem('local_address_select')
                if (localAddressSelectStr) {
                    try {
                        this.addressSelect = JSON.parse(localAddressSelectStr)
                    } catch (error) {
                        this.addressSelect = {}
                    }
                } else {
                    this.getAddressList()
                }
            },
            getAddressList() {
                request({
                    url: api.requestUserAddressList,
                    data: {
                        userId: this.userId,
                    },
                }).then(res => {
                    console.log(res)
                    if (res.errorCode == 200) {
                        let list = res.data
                        let defaultAddress
                        if (Array.isArray(list) || list.length > 0) {
                            let filter =  list.filter(item => item.address_is_default == 'y')
                            filter.length > 0 ? defaultAddress = filter[0] : defaultAddress = list[0]
                            this.addressSelect = defaultAddress
                            sessionStorage.setItem('local_address_select', JSON.stringify(this.addressSelect))
                        }
                    }
                })
            },
            // 手动选择收货地址
            getAddress(item) {
                this.addressSelect = item
                sessionStorage.setItem('local_address_select', JSON.stringify(item))
            },

            formatData(str) {
				let obj = {};
				let requireObj = {
					listStr: [],
					other: ''
				};
				if (typeof str === 'string') {obj = JSON.parse(str)}
				if (typeof str === 'object') {obj = str}
				if (obj && obj.list && obj.list.length > 0) {
					obj.list.forEach(item => {
						if (item.isSelect == '1') {
							requireObj.listStr.push(item.dataName);
						}
					})
				}
				if (obj && obj.other) {
					requireObj.other = obj.other;
				}
				return requireObj;
            },
            submitOrder() {
                
                if (this.userIsAuth == 'never') {
                    this.$confirm('您还未认证企业信息，请先进行认证，才能接单', '企业未认证', {
                        confirmButtonText: '去认证',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$router.push('/auth')
                    })
                }
                if (this.userIsAuth == 'n') {
                    this.$confirm('您的企业信息认证未通过，不能接单，请重新认证', '认证被拒绝', {
                        confirmButtonText: '去认证',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$router.push('/auth')
                    })
                }
                if (this.userIsAuth == 'p') {
                    this.$confirm('您的企业信息认证审核中，认证通过后可以接单。可以拨打客服电话' + this.servicePhone +  '进行咨询', '认证审核中', {
                        confirmButtonText: '确定',
                        showCancelButton: false,
                        type: 'warning'
                    }).then(() => {
                       // 确定
                    })
                }
                if (this.userIsAuth == 'y') {
                    if (!this.addressSelect.address_id) {
                        this.$message.error('请先选择您的联系方式');
                        return;
                    }

                    this.$router.push('/take-order-pay?totalPrice=' + this.detailData.orderTotalPrice
                        + '&orderNumber=' + this.detailData.orderNumber
                        + '&addressId=' + this.addressSelect.address_id
                        + '&orderName=' + this.detailData.orderName  
                    )
                }
            }

        }
    }
</script>

<style scoped="scoped" lang="scss">
    .detail-take-order-page {

        /* 公共 font-size */
        .c-font {
            font-size: 14px;
            line-height: 22px;
            &.grey {
                color: rgba(0, 0, 0, 0.45);
            }
            &.black {
                color: rgba(0, 0, 0, 0.85);
            }
            &.red {
                color: #FF4D4F;
            }
            &.blue {
                color: #3F33FF;
            }
            &.mgt-8 {
                margin-top: 8px;
            }
            &.mgt-4 {
                margin-top: 4px;
            }
            &.mgr-8 {
                margin-right: 8px;
            }
        }
        .page-wrap {
            width: 1184px;
            margin: 0 auto;
        }
        .page-sub-title {
            height: 28px;
            font-size: 20px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.85);
            line-height: 28px;
            margin-bottom: 24px;
        }

        .detail-main-wrap {
            padding: 24px;
            background: #FFFFFF;
            border-radius: 2px;
            border: 1px solid rgba(0, 0, 0, 0.06);
            position: relative;
            .cover-info {
                display: flex;
                .cover-img {
                    width: 60px;
                    height: 60px;
                    background: #f5f5f5;
                }
                .right-box {
                    margin-left: 24px;
                }
                .name-line {
                    width: 480px;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 22px;
                }
                .style-line {
                    margin-top: 4px;
                }
            }
            .line-info {
                margin-top: 24px; 
            }
            .key {
                font-size: 14px;
                color: rgba(0, 0, 0, 0.45);
                line-height: 22px;
                margin-right: 8px;
            }
            .value {
                font-size: 14px;
                color: rgba(0, 0, 0, 0.85);
                line-height: 22px;
            }
            .right-info {
                position: absolute;
                right: 24px;
                top: 24px;
                .text1 {
                    font-size: 20px;
                    font-weight: 500;
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 28px;
                }
                .text2 {
                    font-size: 20px;
                    font-weight: 500;
                    color: #FF4D4F;
                    line-height: 28px;
                }
            }
        }
        .mod-title {
            margin-top: 40px;
            font-size: 16px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.85);
            line-height: 24px;
            padding-bottom: 14px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        }
        .pay-box {
            margin-top: 24px;
            padding: 24px;
            background: rgba(0, 0, 0, 0.02);
        }
        .basic-material {
            padding-bottom: 24px;
            .line {
                padding-top: 24px;
            }
            .line-content {
                margin-top: 8px;
            }
            .line-content span {
                margin-right: 24px;
            }
        }
        .size-table-wrap {
            margin-top: 24px;
            width: 100%;
            overflow-y: hidden;
            overflow-x: auto;
        }
        .size-table {
            min-width: 100%;
            border-collapse: collapse;
            border-spacing: 0;
            th {
                background: #FAFAFA;
                height: 40px;
                & + th {
                    border-left: 1px solid #f0f0f0;
                }
            }
            td {
                height: 40px;
                text-align: center;
                border-bottom: 1px solid #f0f0f0;
                & + td {
                    border-left: 1px solid #f0f0f0;
                }
            }
        }
        .style-wrap {
            padding-top: 24px;
        }
        .style-imgs {
            .img {
                display: inline-block;
                margin: 24px 24px 0 0;
                width: 104px;
                height: 104px;
                background: #f0f0f0;
                object-fit: cover;
            }
        }
        .address-box {
            border: 1px solid rgba(230, 162, 60, 1);
            margin-top: 48px;
            padding: 24px;
            border-radius: 2px;
            background: rgba(230, 162, 60, 0.06);
            width: 80%;
        }  
        .address-box-title {
            font-size: 16px;font-weight: bold;
            color: rgba(0, 0, 0, 0.85);
            line-height: 24px;
        }



    }
    
</style>
